var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90028 4.00001H4.97276C5.20942 3.928 5.28414 3.89631 5.509 4.00001C5.73386 4.10372 5.94392 4.3142 6.04524 4.54208L6.58148 5.62622C6.66874 5.82229 6.62351 5.95753 6.58148 6.16829C6.53945 6.37904 6.73707 6.56377 6.58148 6.71035L5.509 7.25242C5.40645 7.35085 5.67059 7.68015 6.04524 8.33656C6.42026 8.99333 6.44783 9.46111 6.58148 9.42069L7.65396 8.87863C7.85717 8.81579 7.98877 8.81017 8.1902 8.87863C8.39162 8.94708 8.60205 9.24653 8.72644 9.42069L9.79892 10.5048C9.94323 10.707 9.822 10.7987 9.79892 11.0469C9.77583 11.2951 9.44173 11.4175 9.26268 11.589L8.72644 12.131C8.54813 12.3017 8.42927 12.6164 8.1902 12.6731C7.95112 12.7298 7.88878 12.7458 7.65396 12.6731C6.49669 12.315 5.43719 11.1732 4.43652 9.42069C3.43363 7.66554 3.10008 6.29367 3.36404 5.08415C3.41728 4.84043 3.19615 4.72509 3.36404 4.54208C3.53193 4.35908 3.66387 4.07202 3.90028 4.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.2de3ce7922e9a2638edb743977e84434.svg";
export { ForwardRef as ReactComponent };